import log from 'loglevel';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Instance from './components/Instance';
import Sdk from './sdk/Sdk';
import { InitOptions } from './types/player';
//import BlastreamPlayerWebComponent from './sdk/webcomponent/BlastreamPlayerWebComponent';

class BlastreamPlayerManager {
  sdk: Sdk;
  element: HTMLElement;

  constructor(blastreamPlayer: Sdk, element: HTMLElement, options: InitOptions) {
    log.setLevel(process.env.NODE_ENV === 'development' ? 'debug' : 'warn');
    log.debug('BlastreamPlayer constructor');
    this.sdk = blastreamPlayer; //new Sdk(options);

    this.element = element;
    const root = ReactDOM.createRoot(this.element);
    root.render(<Instance sdk={this.sdk} />);
  }

  reRender() {
    //TODO create black div in child of element with the same dimensions of the player
    let div = document.createElement('div');
    let height = this.element.offsetHeight;
    let width = this.element.offsetWidth;
    div.style.backgroundColor = this.sdk.options().getBgColor() || 'black';
    div.style.width = `${width}px`;
    div.style.height = `${height}px`;
    this.element.innerHTML = '';
    this.element.appendChild(div);
    const root = ReactDOM.createRoot(this.element);
    root.render(<Instance sdk={this.sdk} />);
  }
}

class BlastreamPlayer extends Sdk {

  manager: BlastreamPlayerManager;

  constructor(element: HTMLElement, options: InitOptions) {
    super(options);
    this.manager = new BlastreamPlayerManager(this, element, options);
  }

  updateOptions(options: InitOptions): void {
    super.updateOptions(options);  
    this.manager.reRender();
  }
}

export default BlastreamPlayer;

